module.exports = __webpack_public_path__ + "static/media/discover.71dfc3b5.svg";